'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var React = require('react');
var SellerLeadCard = require('./SellerLeadCard.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["children", "className", "__css"];
/**
 * SellerLeadCardIcon
 *
 * Displaying the right icon to its porperty type.
 * The prop 'realtyType' on the card sets the right icon.
 * Note: When passing a different icon with the `as` prop, manage the `viewBox` from the external component.
 *
 */
var SellerLeadCardIcon = react.forwardRef(function (props, ref) {
  var _SELLER_REALTY_TYPES$;
  props.children;
  var className = props.className;
  props.__css;
  var rest = _objectWithoutProperties__default["default"](props, _excluded);
  var _useSellerLeadCardCon = SellerLeadCard.useSellerLeadCardContext(),
    realtyType = _useSellerLeadCardCon.realtyType;
  var realtyIcon = (_SELLER_REALTY_TYPES$ = SellerLeadCard.SELLER_REALTY_TYPES[realtyType]) === null || _SELLER_REALTY_TYPES$ === void 0 ? void 0 : _SELLER_REALTY_TYPES$.icon;
  var styles = react.useStyles();
  return /*#__PURE__*/React__default["default"].createElement(react.Icon, _extends__default["default"]({
    as: realtyIcon,
    ref: ref,
    className: utils.cx('chakra-seller-lead-card__icon', className),
    __css: styles.icon
  }, rest));
});
SellerLeadCardIcon.displayName = 'SellerLeadCardIcon';
exports.SellerLeadCardIcon = SellerLeadCardIcon;